import React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"

interface Props {
  children: React.ReactNode
  badgeContent: React.ReactNode
  className?: string
  max?: number
}

export const Badge: React.FC<Props> = ({
  children,
  badgeContent,
  max = 99,
  className,
}) => {
  const displayValue = badgeContent > max ? `${max}+` : badgeContent

  return (
    <StyledBadge.Wrapper>
      {children}
      <StyledBadge.Badge data-testid="badge-number" className={className}>
        {displayValue}
      </StyledBadge.Badge>
    </StyledBadge.Wrapper>
  )
}

const StyledBadge = {
  Wrapper: tw.span`relative inline-flex flex-shrink-0 align-middle`,
  Badge: styled.span`
  ${tw`absolute text-sm text-black bg-yellow-500 top-0 right-0 w-5 h-5 rounded-full flex flex-wrap items-center justify-center`}
  transform: translate(50%, -50%);
`
}
